import { create } from 'zustand';
import { Locale } from '../types';
import apiService from '../services/api';

const STORAGE_KEY = 'mapblLocale';

const isLocale = (value: unknown): value is Locale => value === 'en' || value === 'uk' || value === 'es' || value === 'fr' || value === 'no' || value === 'ro' || value === 'nl';
const browserLocale = (): Locale => {
  const language = typeof navigator !== 'undefined' ? navigator.language.toLowerCase() : '';
  if (language.startsWith('uk')) return 'uk';
  if (language.startsWith('es')) return 'es';
  if (language.startsWith('fr')) return 'fr';
  if (language.startsWith('no') || language.startsWith('nb')) return 'no';
  if (language.startsWith('nl')) return 'nl';
  if (language.startsWith('ro')) return 'ro';
  return 'en';
};

interface LocaleState {
  locale: Locale;
  isInitialized: boolean;
  initialize: () => Promise<void>;
  setLocale: (locale: Locale, persist?: boolean) => void;
}

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: 'en',
  isInitialized: false,

  initialize: async () => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (isLocale(saved)) {
      set({ locale: saved, isInitialized: true });
      return;
    }

    try {
      const detected = await apiService.detectLocale();
      // Edge country headers are derived from the client IP. In local/dev setups
      // they are absent, so the browser language is a better fallback.
      set({
        locale: detected.countryCode ? detected.locale : browserLocale(),
        isInitialized: true,
      });
    } catch {
      set({ locale: browserLocale(), isInitialized: true });
    }
  },

  setLocale: (locale, persist = false) => {
    if (persist) localStorage.setItem(STORAGE_KEY, locale);
    set({ locale, isInitialized: true });
  },
}));
